import { render } from "./SkuImg.vue?vue&type=template&id=abf89ad2&scoped=true"
import script from "./SkuImg.vue?vue&type=script&lang=js"
export * from "./SkuImg.vue?vue&type=script&lang=js"

import "./SkuImg.vue?vue&type=style&index=0&id=abf89ad2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf89ad2"]])

export default __exports__